
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useOnboardingForm } from "@/hooks/useOnboardingForm";
import { OnboardingStepRenderer } from "./onboarding/OnboardingStepRenderer";

export function OnboardingForm() {
  const {
    formData,
    loading,
    onboardingStep,
    handleInputChange,
    handleCheckboxChange,
    handleSelectChange,
    handleRadioChange,
    prevStep,
    handleSubmit
  } = useOnboardingForm();

  return (
    <form onSubmit={handleSubmit} className="max-w-lg mx-auto bg-card border rounded-lg p-6 shadow-sm">
      <OnboardingStepRenderer
        currentStep={onboardingStep}
        formData={formData}
        handleInputChange={handleInputChange}
        handleCheckboxChange={handleCheckboxChange}
        handleSelectChange={handleSelectChange}
        handleRadioChange={handleRadioChange}
      />

      <div className="flex justify-between mt-8">
        {onboardingStep > 0 ? (
          <Button type="button" variant="outline" onClick={prevStep}>
            <ChevronLeft className="mr-2 h-4 w-4" />
            Previous
          </Button>
        ) : (
          <div></div>
        )}
        
        <Button type="submit" disabled={loading}>
          {onboardingStep < 6 ? (
            <>
              Next
              <ChevronRight className="ml-2 h-4 w-4" />
            </>
          ) : loading ? (
            "Processing..."
          ) : (
            "Complete Registration"
          )}
        </Button>
      </div>
    </form>
  );
}
